import React from "react";
import { Slide } from "react-awesome-reveal";
import useBreakpoint from "../../hooks/useBreakpoints";
import Gradient from "../Gradient";
import DommShadow from "../../assets/images/dommWithShadow.png";
import BigD from "../../assets/images/bigD.svg";
import Sticker from "../../assets/images/sticker.png";
import HandCoffee from "../../assets/images/coffeehand.png";

const AboutSection = ({ data, anchorId }) => {
  const { isLaptop } = useBreakpoint();

  if (!data) return null;

  const { title, description, subTitle } = data;

  return (
    <section className="section about-section flex-wrapper" id={anchorId}>
      <div className="flex-container about-section__container">
        <Slide direction="left" duration={1000}>
          <div className="left-image">
            <img
              className="left-image__domm"
              src={isLaptop ? DommShadow : BigD}
              alt="Domm"
            />
            <img src={Sticker} alt="Sticker" />
          </div>
        </Slide>
        <div className="description-container">
          <span className="subTitle">{subTitle}</span>
          <h2 className="about-title">{title}</h2>
          <p className="about-description">{description}</p>
        </div>

        <div className="right-image">
          <Slide direction="right" duration={1000}>
            <img src={HandCoffee} alt="Coffee" />
          </Slide>
        </div>
      </div>
      <Gradient
        imageName="gradient3"
        className="gradientRight"
        right="0px"
        bottom="-300px"
        left="initial"
        size="contain"
      />
    </section>
  );
};

export default AboutSection;
